export enum WorkflowStatus {
  START = 'START',
  POST_COMPLETED = 'POST_COMPLETED',
  ESTRAZIONE_LAVORAZIONI_COMPATIBILI_LETTURA_FILE = 'ESTRAZIONE_LAVORAZIONI_COMPATIBILI_LETTURA_FILE',
  ESTRAZIONE_LAVORAZIONI_COMPATIBILI_RICERCA_PREZZARIO = 'ESTRAZIONE_LAVORAZIONI_COMPATIBILI_RICERCA_PREZZARIO',
  ESTRAZIONE_LAVORAZIONI_COMPATIBILI_COMPLETATA = 'ESTRAZIONE_LAVORAZIONI_COMPATIBILI_COMPLETATA',
  ESTRAZIONE_LAVORAZIONI_SUGGERITE_IN_CORSO = 'ESTRAZIONE_LAVORAZIONI_SUGGERITE_IN_CORSO',
  ESTRAZIONE_LAVORAZIONI_SUGGERITE_COMPLETATA = 'ESTRAZIONE_LAVORAZIONI_SUGGERITE_COMPLETATA',
  ELABORAZIONE_NUOVO_PREZZO_IN_CORSO = 'ELABORAZIONE_NUOVO_PREZZO_IN_CORSO',
  ELABORAZIONE_NUOVO_PREZZO_COMPLETATA = 'ELABORAZIONE_NUOVO_PREZZO_COMPLETATA',
  ERRORE = 'ERRORE',
}
